import { render, staticRenderFns } from "./EditActivityLeaderboardDialog.vue?vue&type=template&id=e60c7732&scoped=true"
import script from "./EditActivityLeaderboardDialog.vue?vue&type=script&lang=js"
export * from "./EditActivityLeaderboardDialog.vue?vue&type=script&lang=js"
import style0 from "./EditActivityLeaderboardDialog.vue?vue&type=style&index=0&id=e60c7732&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60c7732",
  null
  
)

export default component.exports